import { LayoutGrid, List } from "lucide-react";

const VIEWS = [
  ["grid", "Grid", LayoutGrid],
  ["list", "List", List],
];

// Grid / List switch for Your Ducks (the page remembers the choice).
export const ViewToggle = ({ view, onChange }) => (
  <div role="group" aria-label="View" data-testid="your-ducks-view-toggle" className="grid grid-cols-2 gap-1 rounded-full border border-border bg-muted/40 p-1">
    {VIEWS.map(([id, label, Icon]) => (
      <button
        key={id}
        type="button"
        aria-pressed={view === id}
        data-testid={`your-ducks-view-${id}`}
        onClick={() => onChange(id)}
        className={`flex items-center justify-center gap-1.5 rounded-full h-9 px-3 text-sm font-semibold transition-colors duration-200 ${view === id ? "bg-foreground text-background" : "text-muted-foreground hover:text-foreground"}`}
      >
        <Icon className="h-4 w-4" />
        <span className="hidden sm:inline">{label}</span>
      </button>
    ))}
  </div>
);
